import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'warm' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    warm: 'bg-warm-white',
    navy: 'bg-navy text-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className}`} data-id="element-208">
      <div className="max-w-4xl mx-auto w-full" data-id="element-209">{children}</div>
    </section>;
}